<ng-content select="app-expansion-panel-header"></ng-content>
<div class="app-expansion-panel-content-wrapper" [attr.inert]="expanded ? null : ''">
  <div class="app-expansion-panel-content" role="region" [id]="contentId" [attr.aria-labelledby]="headerId">
    <div class="app-expansion-panel-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
